/**
 * @file BackButtonComponent.tsx
 * @description
 * -----------------------------------------------------
 * Componente de botón de volver atrás
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2024-03-03
 * @author Correcta
 * @copyright © Correcta
 * @license Private
 * */

"use client";
import React from "react";
import ButtonComponent from "@/components/ui/ButtonComponent";
import { useRouter } from "@/i18n/routing";
import { useTranslations } from "use-intl";
import { ArrowLeft } from "lucide-react";
import { TYPE_BUTTON } from "@/constants/button";
import { useLoadingOverlay } from "@/context/LoadingOverlayProvider";
import { BackButtonComponentProps } from "@/types/ui";

const BackButtonComponent: React.FC<BackButtonComponentProps> = ({
  className,
  disabled,
  label,
  href,
  dynamicLabel,
  status = "back",
}) => {
  const router = useRouter();
  const buttons = useTranslations("Buttons");
  const { show } = useLoadingOverlay();

  const handleBack = () => {
    show();
    if (href) {
      router.push(href);
    } else {
      router.back();
    }
  };

  return (
    <ButtonComponent
      type={TYPE_BUTTON}
      onClick={handleBack}
      status={status}
      ariaLabel={
        label
          ? label
          : dynamicLabel
            ? buttons("buttonBack", dynamicLabel)
            : buttons("buttonBack")
      }
      className={className}
      disabled={disabled}
    >
      <ArrowLeft size={16} />
      {label === ""
        ? null
        : label
          ? label
          : dynamicLabel
            ? buttons("buttonBack", dynamicLabel)
            : buttons("buttonBack")}
    </ButtonComponent>
  );
};

export default BackButtonComponent;
